import { ACTION_CREATE, ACTION_EDIT } from '../../request';
import { Voter } from '../voter';

export class WebsitesVoter extends Voter {
    static getLimitByRole(role) {
        switch (role) {
            case 'basic':
            case 'start400':
            case 'pro400':
                return 1;
            case 'business400':
                return 10;
            default:
                return 3;
        }
    }

    supports(request) {
        return request.resource === 'websites';
    }

    vote(request) {
        if (request.includes(ACTION_CREATE) && !this.canCreate(request)) {
            return false;
        }

        if (request.role === 'basic') {
            if (request.includes(ACTION_EDIT) && !this.canEditBasic(request)) {
                return false;
            }
        }

        //
        return true;
    }

    canCreate(request) {
        const websitesCount = request.user.workspace.quantities.websites;
        const roleLimit = WebsitesVoter.getLimitByRole(request.role);

        return websitesCount < roleLimit;
    }

    canEditBasic(request) {
        const values = request.subject;

        if (!values) {
            return true;
        }

        // if (!values.branding) {
        //     return false;
        // }

        // if (values.seo?.title || values.seo?.description) {
        //     return false;
        // }

        // if (values.tracking?.google || values.tracking?.facebook || values.tracking?.yandex) {
        //     return false;
        // }

        //
        return true;
    }
}
